import React, { Suspense, useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import Loader from "../Layout/Loader";
import LayoutRoutes from "./LayoutRoutes";
import PrivateRoute from "./PrivateRoute";
import { authRoutes } from "./AuthRoutes";
import SignIn from "../Billerq/Sign/SignIn";
import CompanySection from "../Billerq/AddCompany/CompanySection";
import SubscriptionSection from "../Billerq/Subscription/AddSubscription";
import Error from "../Billerq/Error/Error";


const Routers = () => {
  const location = useLocation();
  useEffect(() => {
    localStorage.setItem('lastVisitedPage', location.pathname);
  }, [location]);

  const appVersion = 'V1.2';
  const savedVersion = localStorage.getItem('rks_version');

  if (savedVersion !== appVersion) {
    localStorage.clear();
    localStorage.setItem('rks_version', appVersion);
    window.location.reload();
  }

  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        <Route path='/' element={<SignIn />} />
        <Route path="error" element={<Error />} />
        <Route
          path="/*"
          element={
            <PrivateRoute>
              <LayoutRoutes />
            </PrivateRoute>
          }
        />

        <Route
          path="/"
          element={
            localStorage.getItem("rksLogin") ? (
              <Navigate to="/dashboard" />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        {authRoutes.map(({ path, Component }, i) => (
          <Route path={path} element={Component} key={i} />
        ))}
      </Routes>
    </Suspense>
  );
};

const Router = () => {
  return (
    <BrowserRouter basename="/">
      <Routers />
    </BrowserRouter>
  );
};
export default Router;
